"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPreviousPlacementDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
let OpportunityPreviousPlacementDetails = class OpportunityPreviousPlacementDetails {
    constructor(id, opportunityId, challengesAndMitigation, existingCompetition, remarks) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.challengesAndMitigation = challengesAndMitigation;
        this.existingCompetition = existingCompetition;
        this.remarks = remarks;
    }
};
exports.OpportunityPreviousPlacementDetails = OpportunityPreviousPlacementDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousPlacementDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPreviousPlacementDetails.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "challenges_and_mitigation", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPreviousPlacementDetails.prototype, "challengesAndMitigation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "existing_competition", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPreviousPlacementDetails.prototype, "existingCompetition", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPreviousPlacementDetails.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.previousPlacementDetails, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPreviousPlacementDetails.prototype, "opportunity", void 0);
exports.OpportunityPreviousPlacementDetails = OpportunityPreviousPlacementDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_previous_placement_details" }),
    tslib_1.__metadata("design:paramtypes", [Number, Number, String, String, String])
], OpportunityPreviousPlacementDetails);
